<template>
  <div class="animated fadeIn">
    <faqdetails v-if="isfaq"></faqdetails>
  </div>
</template>

<script>
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
export default {
  name: "Setup",
  components: {
    faqdetails,
  },
  data: () => {
    return {
      isfaq: true,
      items: [
        {
          id: 1,
          name: "SETUP",
          children: [
            {
              id: 2,
              name: "FAQ",
            },
          ],
        },
      ],
      open: [1, 2],
      search: null,
    };
  },
  mounted: async function () {
    this.provider = this.$store.getters["auth/getUserID"];
  },
  computed: {},
};
</script>

<style scoped>
.mymodalclass > div {
  margin-top: 45px !important;
}
.text-center {
  text-align: center !important;
}
[data-font="20"] {
  font-size: 20px;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
